// DRINK DRAG & DROP CODE
<template>

    <v-container class="pa-0 ma-0" id="mainhomecontainer">
        <v-card class="overview" elevation="0">
            <v-overlay v-model="overlay"
                :color= "storeBusiness.themecolor!=NULL?storeBusiness.themecolor:'#FE5800'" >
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>

            <v-card-text class="d-flex d-md-none">
                <v-row align="start" justify="center">
                    <v-col cols="12" sm="8" md="10">

                            <v-card-title>
                                Drink List
                                <div class="flex-grow-1"></div>

                                    <v-btn color="primary" class="ml-3"
                                    @click="$router.push({name:'createbusinessdrinkitem',params:{id:JSON.parse($store.getters.business).id}})"
                                    >{{$t('zz_create_drink_item')}}</v-btn>

                            </v-card-title>
<!-- MOBILE XSM SM Screen Szie VUE   -->
                            <v-row >
                                <v-col cols="12" md="12">
                                    <v-card v-for="(item, index) in drinkitems" :key="index" tile class="cardlist pa-3 mb-3">
                                        <v-row>
                                            <v-col cols="4" class="pt-0 pb-0">
                                                <v-avatar
                                                    tile
                                                    class="cardlist"
                                                >
                                                    <img :src="index.fimage" />
                                                </v-avatar>
                                            </v-col>
                                            <v-col cols="8" md="8">
                                                <v-row class="ml-0 mr-0">
                                                    <v-col cols="9" class="pa-0">
                                                        <div><h3 class="foodtitle">{{item.name}}</h3></div>
                                                        <div>{{index.brand}}</div>
                                                    </v-col>
                                                    <v-col cols="3" md="3">
                                                        <v-btn @click="editFoodItem(item.id)" color="primary " fab x-small dark
                                                        class="mt-2 mb-2">
                                                            <v-icon>mdi-pencil</v-icon>
                                                        </v-btn>
                                                        <v-btn @click="deleteItem(item.id)" color="primary " fab x-small dark class="">
                                                            <v-icon>mdi-delete</v-icon>
                                                        </v-btn>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                    </v-card>
                                </v-col>
                            </v-row>
                    </v-col>
                </v-row>
            </v-card-text>
<!-- DRAG & DROP EXPLINATION BUTTON  -->
            <v-row class="d-none d-md-flex " justify="right">
                <v-col cols="12" class="text-left">
                    <!-- <v-btn color="primary" class="ml-3 " -->
                     <v-row>
                        <div class="pl-11">
                            <v-dialog
                                v-model="dialog"
                                width="800"
                                v-bind="attrs"
                                v-on="on">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                    elevation="2"
                                    color="#FE5800"
                                    fab
                                    small
                                    v-bind="attrs"
                                    v-on="on"
                                    >
                                        <v-icon color="white">mdi-information-variant</v-icon>
                                    </v-btn>
                                </template>
                                <v-card>
                                    <v-card-title class="section-spread text-h1 zzorganebg">
                                        <h1 class="font-weight-bold display-2 text--pr"><v-icon style="font-size:50px;color:white" class="pr-2">mdi-drag-variant</v-icon>{{$t('zz_drag_and_drop_title')}}</h1>
                                    </v-card-title>
                                    <p class="pt-5 px-4">
                                        <span v-html="$t('zz_drag_and_drop_explination')">
                                        </span>
                                    </p><br>
                                    <v-divider></v-divider>
                                    <p class="pt-5 px-4"><span v-html="$t('zz_remember_to_save')"></span></p><br>
                                </v-card>
                            </v-dialog>
                        </div>
                         <v-btn elevation="2" color="#FE5800" class="ml-3 "@click="$router.push({name:'createbusinessdrinkitem',params:{id:JSON.parse($store.getters.business).id}})">
                            {{$t('zz_create_drink_item')}}
                        </v-btn>
                        <v-btn elevation="10" color="#FE5800" class="bounce ml-3" v-if="isdragged" @click="savemenu" >
                            {{$t('zz_save_food_menu_changes')}}
                        </v-btn>
                        <span class="ml-3 success--text font-weight-bold" v-if="savemsg!=''">
                            {{savemsg}}
                        </span>
                    </v-row>
                </v-col>
            </v-row>
            <!-- <p class="pt-5 pl-4"><span v-html="$t('zz_drag_and_drop')"></span></p> -->



            <v-card-text  class="d-none d-md-flex" style="width:100%;overflow-x:scroll;height:1500px;">
                <div  class="overflowcol" >
                    <draggable v-model="drinkitems.types"
                     @start="drag=1" @end="dragfooditem('c')" >
                        <transition-group>
                            <div  class="maxtall course_col" :class="drag?move:''" v-for="type in drinkitems.types" :key="'c-'+type.id" tile>
                                <v-card elevation="24" class="mb-5 maxtall dnd-card-height course-heading-card">
                                  <v-card-text class="white--text aligncenter ma-0 pa-0 py-2">
                                        <p class="courseheading ma-0 pa-0">
                                            {{type.name}}
                                        </p>
                                  </v-card-text>

                                  </v-card>
                                  <div class="mt-12"></div>
                                  <!-- <v-card> -->
                                    <v-card-content>
                                        <draggable @start="dragitem=1;" @end="dragfooditem('i');" v-model="type.items">
                                            <transition-group>

                                                <v-card elevation="24" class="mb-3 maxtall" :class="drinkitem.separation?'seperatordrinkdnd':''" v-for="(drinkitem, ind) in type.items" :key="'c-'+drinkitem.id">
                                                    <v-col cols="12" md="12" no-gutters class="ma-0 pa-0">
                                                        <v-row no-gutters class="pa-0 ma-0 section-spread">
    <!-- Image  -->                                        <v-col cols="4" md="4" class="pt-0 pb-0 pl-0" v-if="drinkitem.separation==0">
                                                                <container jusitfy:start>
                                                                    <v-img  height="100" class="text-left dnd-drink-image-max  pl-0 pt-0 pb-0 pr-0" v-if="drinkitem.separation==0"  :class="drinkitem.showitem==0? 'inactiveimg' :''"
                                                                  contain
                                                                  :src="drinkitem.fimage"/>

                                                                </container>
                                                            </v-col>

                                                            <!-- ACTIVE TEXT & IMAGES  -->
                                                            <v-col v-if="drinkitem.showitem==1" cols="6" md="6" class="pt-2 pb-2 pl-5">
                                                                <v-row class="drink-title-dnd" :class="drinkitem.separation?'white-text-heading':''" >
                                                                    <v-card-text class="text-left ma-0 pa-0 text-truncate">
                                                                        {{drinkitem.name}}
                                                                    </v-card-text>
                                                                </v-row>
                                                                <v-row v-if="drinkitem.separation==0" class="drink-subtitle-dnd">
                                                                    <v-card-text class="text-left ma-0 pa-0 text-truncate">
                                                                        {{drinkitem.subtitle}}
                                                                    </v-card-text>
                                                                </v-row>
                                                                <v-row v-if="drinkitem.separation==0" class="drink-strapline-dnd">
                                                                    <v-card-text class="text-left ma-0 pa-0 text-truncate">
                                                                        {{drinkitem.brand}}
                                                                    </v-card-text>
                                                                </v-row>
                                                            </v-col>


                                                            <!-- GREY OUT INACTIVE ITEM TEXT  -->


                                                            <v-col  v-else cols="6" md="6" class="pt-2 pb-2 pl-5">
                                                                <v-row class="drink-title-dnd-hidden" :class="drinkitem.separation?'hidden-text-heading':''" >
                                                                    <v-card-text class="text-left ma-0 pa-0 text-truncate">
                                                                        {{drinkitem.name}}
                                                                    </v-card-text>
                                                                </v-row>
                                                                <v-row v-if="drinkitem.separation==0" class="drink-subtitle-dnd-hidden">
                                                                    <v-card-text class="text-left ma-0 pa-0 text-truncate">
                                                                        {{drinkitem.subtitle}}
                                                                    </v-card-text>
                                                                    </v-row>
                                                                <v-row v-if="drinkitem.separation==0" class="drink-strapline-dnd-hidden">
                                                                    <v-card-text class="text-left ma-0 pa-0 text-truncate">
                                                                        {{drinkitem.brand}}
                                                                    </v-card-text>
                                                                </v-row>
                                                            </v-col>




<!-- Gogs and Edit Menu  -->                                <v-col no-gutters cols="2" md="2" class="alignrigth pr-0">
                                                                <v-menu bottom right >
                                                                    <template v-slot:activator="{ on, attrs }" class="pa-0 ma-0">
                                                                        <v-btn no-gutters class="pa-0 ma-0" color="#FE5800" icon v-bind="attrs" v-on="on">
                                                                            <!-- <v-icon>fa fa-cog fa-spin</v-icon> -->
                                                                            <v-icon no-gutters class="compact-toggle-dnd-1" :class="drinkitem.showitem==0? 'inactivecogs' :''">fa fa-cogs</v-icon>
                                                                        </v-btn>
                                                                    </template>
<!-- Quick Edit Menu  -->                                           <v-list dense no-gutters ma-0 pa-0 class="px-5 pt-1">
                                                                        <v-icon color="red" icon dark class="close-menu-left pa-0 ma-0 pt-2 pl-2">
                                                                            mdi-close-circle
                                                                        </v-icon>
                                                                        <!-- <v-list dense no-gutters ma-0 pa-0 class="px-5 pt-1"> -->
                                                                        <v-list-item>
                                                                            <span class="mt-4 edit-item-name">{{drinkitem.name}}</span>
                                                                        </v-list-item>
                                                                        <v-list-item>
                                                                            <div cols="12" v-if="drinkitem.showitem==1 ">
                                                                                <v-switch class="pl-1 compact-toggle-dnd-1" inset color="success" :input-value="shw"  @click="updateshowitem(drinkitem.typeid,0)" :id="'showonitem-'+drinkitem.id"></v-switch>
                                                                            </div>
                                                                            <div v-else>
                                                                                <v-switch class="pl-1 compact-toggle-dnd-1" inset color="red" :input-value="nshw"  @click="updateshowitem(drinkitem.typeid,1)" :id="'showonitem-'+drinkitem.id"></v-switch>
                                                                            </div>
                                                                        </v-list-item>
                                                                        <v-list-item v-if="drinkitem.separation==0">
                                                                            <v-btn icon @click.prevent="drinkitemimage(drinkitem.id)" color="#FE5800 " fab x-small dark class="mt-2 mb-2">
                                                                                <v-icon>mdi-camera-plus-outline</v-icon>
                                                                            </v-btn>
                                                                        </v-list-item>
                                                                        <v-list-item>
                                                                            <v-btn icon @click="editFoodItem(drinkitem.id)" color="#FE5800 " fab x-small dark
                                                                                class="mt-2 mb-2">
                                                                                <v-icon>mdi-square-edit-outline</v-icon>
                                                                            </v-btn>
                                                                        </v-list-item>
                                                                        <v-list-item>
                                                                            <v-btn icon @click="deleteItem(drinkitem.id)" color="#FE5800 " fab x-small dark class="">
                                                                                 <v-icon>mdi-trash-can-outline</v-icon>
                                                                            </v-btn>
                                                                        </v-list-item>
                                                                    </v-list>
                                                                </v-menu>
                                                            </v-col>
                                                        </v-row>
                                                    </v-col>
        <!-- TOGGLE SWITCH SHOW OR HIDE ITEM  -->
                                                                <!-- <div cols="12" v-if="drinkitem.showitem==1" class="pr-12">
                                                                    <v-switch class="pl-1 compact-toggle-dnd" inset  color="success" :input-value="shw"  @click="updateshowitem(drinkitem.typeid,0)" :id="'showonitem-'+drinkitem.id"></v-switch>
                                                                </div>
                                                                <div v-else>
                                                                    <v-switch class="pl-1 compact-toggle-dnd" inset  color="red" :input-value="nshw"  @click="updateshowitem(drinkitem.typeid,1)" :id="'showonitem-'+drinkitem.id"></v-switch>
                                                                </div> -->


    <!-- PRICE ROW      -->
                                                    <v-row v-if="drinkitem.measures.price>0 && !drink.separation">
                                                        <v-col cols="12" v-for="(measure, index) in drinkitem.measures" :key="'p'+index" class="price-row">
                                                            <div class="pb-1">
                                                            <v-row>
                                                                <!-- <v-col cols="2"></v-col> -->
                                                                <v-col cols="4" md="4" class="drink-price-measure-list mr-0">
                                                                    {{measure.mname}}
                                                                </v-col>
                                                                <v-col cols="4" md="4" class="drink-price-unit-list mr-0">
                                                                    {{measure.qty}}{{measure.unit}}
                                                                </v-col>
                                                                <v-col cols="4" md="4" class="drink-price-list mr-0">
                                                                    {{measure.price}}
                                                                </v-col>
                                                            </v-row>
                                                            </div>
                                                        </v-col>
                                                    </v-row>
                                                </v-card>
                                            </transition-group>
                                        </draggable>
                                    </v-card-content>
                                <!-- </v-card> -->
                            </div>
                        </transition-group>
                    </draggable>
                </div>


                <v-dialog v-model="itemimagedialog" content-class="itemdetaildialog" scrollable fullscreen hide-overlay transition="dialog-bottom-transition">
                        <v-card tile class="bbredD" elevation="3">
                            <v-card-text class="pa-0 carddetail" elevation="3" color="#fff">
                                <v-form class="" v-model="valid" enctype="multipart/form-data" id="editfooditem">
                                    <v-row>
                                        <v-col cols="12" md="12" class="text-center mt-10"><h4>{{$t('zz_update')}}</h4></v-col>
                                    </v-row>
                                    <v-row clos="10" md="10" class="mx-2 px-5" style="justify-content: center">
                                        <p>ONLY USE IMAGES THAT YOU HAVE PERMISSION TO USE</p>
                                    </v-row>
                                    <div style="bottom:10%; position:absolute">
                                        <v-row>
                                            <v-col cols="12" md="12" sm="12">
                                            <v-row v-if="mainimguploading">
                                                <v-col cols="12" class="text-center">
                                                    <v-progress-circular
                                                    indeterminate
                                                    color="primary"
                                                    ></v-progress-circular>
                                                </v-col>
                                            </v-row>
                                            <Cropper v-show="uploadedimage!=null && uploadedimage!='null' " class="cropper" :src="uploadedimage" @change="onChange" />
                                            <v-row>
                                                <v-col cols="12" md="12" sm="12" class="text-center mb-5 mt-3" >
                                                <!-- <v-img class="backimg"  :src="addphoto" @click="$refs.file.click()" style="max-height:200px;background-size: contain;"> -->
                                                    <input
                                                    type="file"
                                                    ref="file"
                                                    @change="uploadImage($event)"
                                                    accept="image/*"
                                                    class=""
                                                    id="itemimage"
                                                    />
                                                <!-- </v-img> -->
                                                </v-col>
                                                <v-col cols="12" md="12" sm="12" class="text-center mb-9">
                                                    <v-row align="center" justify="space-around">
                                                        <v-btn
                                                            depressed
                                                            color="#fe5800"
                                                            @click.stop="updateimage">
                                                            {{$t('zz_update')}}
                                                        </v-btn>
                                                    </v-row>
                                                </v-col>
                                            </v-row>
                                            </v-col>
                                        </v-row>
                                    </div>
                                </v-form>
                            </v-card-text>

                        </v-card>

                        <v-footer
                        absolute
                        class="font-weight-medium "
                        color="transparent">
                            <v-col
                                class="text-center"
                                cols="12">
                                <v-btn @click="backtomenuimage" fab small color="#fe5800" >
                                    <v-icon class="white--text ">mdi-close</v-icon>
                                </v-btn>
                            </v-col>
                        </v-footer>
                    </v-dialog>
            </v-card-text>

        </v-card>
    </v-container>

</template>
<script>
    import Vue from 'vue'
    import draggable from 'vuedraggable'
    import { Cropper } from 'vue-advanced-cropper';

    export default {
        props: {
        source: String
    },
    data: () => ({
            shw:true,
            nshw:false,
          switchValue:false,
          showonitem:true,
          headers: [
          {
            text: 'Photo',
            align: 'start',
            sortable: false,
            value: 'photo',
          },
          { text: 'Title', value: 'title' },
          { text: 'Viewed', value: 'viewed' },
          { text: 'Favorites', value: 'favorites' },
          { text: '%', value: 'per' },
          { text: 'Special', value: 'special' },
          { text: 'Price', value: 'price' },
          { text: 'Section', value: 'section' },

        ],

        foodview:'grid',

        savemsg:'',
        isdragged:0,
        dragitem:0,
        drag:0,
        overlay: false,

        juzzapLogo: require("@/assets/logo-Copy.png"),

        id:'',

        itemimg:"",

        drinkitems:[],
        itemimagedialog:false,
        valid:true,
        mainimguploading:false,
        uploadedimage:null,
        itemupdateid:0,


    }),
    created()
    {
        this.storeBusiness=JSON.parse(localStorage.getItem('business'));



        this.id=this.storeBusiness.id;

        this.overlay=true;

        this.$http
         .get(this.$apidomain+"drinkitemlistpwa/"+this.id)
        .then(res => {
          if(res.data.success==0)
          {
              this.drinkitems=res.data.drinkitems;
                this.overlay=false;


          }
          })
          .catch(err => {
                this.overlay=false;

            console.log(err.response);


          });
    },
    components:
    {
        draggable,
        Cropper,

    },
    methods:
    {
        drinkitemimage(fiid)
        {
            
            this.itemimagedialog=true;
            this.itemupdateid=fiid;
            // this.fooditemshowonmenu=showonmenu;


        },
        backtomenuimage()
        {
            this.itemimagedialog=false;
            

        },
        uploadImage(event)
        {
			// Reference to the DOM input element
			var input = event.target;
			// Ensure that you have a file before attempting to read it
			if (input.files && input.files[0]) {
                    this.mainimguploading=true;

					// create a new FileReader to read this image and convert to base64 format
					var reader = new FileReader();
					// Define a callback function to run, when FileReader finishes its job
					reader.onload = (e) => {
							// Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
							// Read image as base64 and set to imageData
							this.uploadedimage = e.target.result;
					}
					// Start the reader job - read file as a data url (base64 format)
					reader.readAsDataURL(input.files[0]);
			}
        },
        onChange({coordinates, canvas})
        {

			this.coordinates = coordinates
			// You able to do different manipulations at a canvas
			// but there we just get a cropped image
            this.image = canvas.toDataURL()
            this.mainimguploading=false;

        },
        dataURLtoFile(dataurl, filename)
        {

                var arr = dataurl.split(','),
                    mime = arr[0].match(/:(.*?);/)[1],
                    bstr = atob(arr[1]),
                    n = bstr.length,
                    u8arr = new Uint8Array(n);

                while(n--){
                    u8arr[n] = bstr.charCodeAt(n);
                }

                return new File([u8arr], filename, {type:mime});
        },
        updateimage()
        {
            let fd = new FormData(document.getElementById("editfooditem"));

            if(this.uploadedimage!=null){
                fd.append('imagea',this.dataURLtoFile(this.image,document.getElementById('itemimage').files[0].name));
            }

            this.overlayfooditemimageupdate=true;

             this.$http
            .post(this.$apidomain+"updatedrinkItemImage/"+this.itemupdateid, fd)
            .then(res => {
                if(res.data.success==1)
                {

                    this.itemimagedialog=false;
                    this.overlayfooditemimageupdate=false;


                    // this.$router.push({name:'food',params:{tag:this.business.id,key:''}});
                    // this.$router.push({name:'businessfoodlist'});
                    this.$router.go('/');

                }
                else
                {
                    this.overlay=false;
                    this.itemimagedialog=false;

                    let errmsg=[];
                    for(var prop in res.data.errors){
                        errmsg.push(res.data.errors[prop][0]);
                    }
                    alert(errmsg[0]);
                }
            })
            .catch(err => {
                    this.overlay=false;

                    console.log(err.response);
            });

        },


        editFoodItem(drinkitemid)
        {
            this.$router.push({name:'editbusinessdrinkitem',params:{id:drinkitemid,business_id:this.storeBusiness.id}});

        },
        deleteItem(drinkitemid)
        {
                if (confirm("Are you sure you want to delete this Items?"))
                {

                this.$http
                    .post(this.$apidomain+"deletedrinkitem/"+drinkitemid)
                    .then(res => {
                        if(res.data.success==0)
                        {
                            this.$router.push({name:'businesslistnew'});
                        }
                        else if(res.data.success==1)
                        {
                            this.$http
                            .get(this.$apidomain+"drinkitemlistpwa/"+this.id)
                            .then(res => {
                            if(res.data.success==0)
                            {
                                this.drinkitems=res.data.drinkitems;
                                    this.overlay=false;


                            }
                            })
                            .catch(err => {
                                    this.overlay=false;

                                console.log(err.response);


                            });
                        }
                        this.drinkitems = res.data.drinkitems;
                    })
                    .catch(err => {
                    console.log(err.response);
                    });


                }
        },

        savemenu()
        {
            this.overlay=true;

            this.$http
            .post(this.$apidomain+"savebusinessdrinkmenu",{data:JSON.stringify(this.drinkitems),businessid:this.id})
            .then(res => {
                if(res.data.success==1)
                {
                        this.isdragged=0;
                        this.savemsg=res.data.msg;
                        this.items = res.data.items;
                        this.$http
                        .get(this.$apidomain+"drinkitemlistpwa/"+this.id)
                        .then(res => {
                        if(res.data.success==0)
                        {
                            this.drinkitems=res.data.drinkitems;
                                this.overlay=false;


                        }
                        })
                        .catch(err => {
                                this.overlay=false;

                            console.log(err.response);


                        });
                }
                // this.fooditems = res.data.fooditems
                // this.overlay=false;


            })
            .catch(err => {
                console.log(err.response);
                this.overlay=false;

            });
        },
        dragfooditem(dtype)
        {
            this.isdragged=1;
            this.savemsg='';
            if(dtype=='c')
            {
            this.drag=0;
            }

            if(dtype=='i')
            {
            this.dragitem=0;
            }

        } ,

        updateshowitemold(itemid,courseid,showitem)
        {
            this.overlay=true;

            //  let showitem=showitem;
            //showitem= document.getElementById('showonitem-'+itemid).value;

            // console.log('show item value ' + showitem+' itemid '+itemid);

            this.$http
            .post(this.$apidomain+"updatedrinkitemshow/"+itemid,{showitem:showitem})
            .then(res => {
                if(res.data.success==1)
                {


                        this.$http
                        .get(this.$apidomain+"drinkitemlistpwa/"+this.id)
                        .then(res => {
                        if(res.data.success==0)
                        {
                            this.drinkitems=res.data.drinkitems;
                            this.overlay=false;


                        }
                        })
                        .catch(err => {
                            this.overlay=false;

                            console.log(err.response);


                        });

                }



            })
            .catch(err => {
                console.log(err.response);
                this.overlay=false;

            });

        },

        updateshowitem(drinkitemtypeid,showitem)
        {
            this.overlay=true;

            //  let showitem=showitem;
            //showitem= document.getElementById('showonitem-'+itemid).value;

            // console.log('show item value ' + showitem+' itemid '+itemid);

            this.$http
            .post(this.$apidomain+"updatedrinkitemtypeshow/"+drinkitemtypeid,{showitem:showitem})
            .then(res => {
                if(res.data.success==1)
                {

                         this.overlay=true;

                            this.$http
                            .get(this.$apidomain+"drinkitemlistpwa/"+this.id)
                            .then(res => {
                            if(res.data.success==0)
                            {
                                this.drinkitems=res.data.drinkitems;
                                    this.overlay=false;


                            }
                            })
                            .catch(err => {
                                    this.overlay=false;

                                console.log(err.response);


                            });

                }



            })
            .catch(err => {
                console.log(err.response);
                this.overlay=false;

            });

      },
    }


    }

</script>

<style>
.cardlistdrink{

    border-radius: 5px !important;
    padding-left: 5px;
    padding-right: 5px;
    padding-bottom: 50px;
    background-color: rgb(234, 103, 103);
}

.course-heading-card{

    border-radius: 0px !important;
    padding-left: 5px;
    padding-right: 5px;
    padding-bottom: 5px;
    background-color:#FE5800 !important;
    color: white !important;
}


.cardlistnone{
    max-width: 100px !important;
    max-height: 75px !important;
    border-radius:none;
    border:none !important;
    box-shadow: none !important;

}

.cardlist{

        max-width: 960px;
        /*max-height: 150px;*/
        border-top-right-radius: 0px !important;
        border-bottom-left-radius: 0px !important;
    }

 .cardlistheading{
    max-width: 400px;
    /* border-radius:none; */
    border:none !important;
    box-shadow: none !important;
    background-color: crimson !important;

    }

.drink-title-dnd
    {
        font-size:16px !important;
        font-weight:500 !important;
        color: rgb(26, 26, 26) !important;
        text-transform:uppercase !important;
        padding-top: 1px !important;
        padding-bottom: 0px !important;
        line-height: 1;
    }

.drink-subtitle-dnd{
        padding-top: 1px !important;
        padding-bottom: 0px !important;
        color: rgb(26, 26, 26) !important;
        font-size:14px !important;
		font-weight: 300 !important;
        line-height: 1;
        text-transform:capitalize !important;
        text-align: justify !important;
        /* line-height: 14px !important; */
        padding-left: 0px !important;

    }

.drink-strapline-dnd{
    padding-top: 1px;
    padding-bottom: 0px;
    color: rgb(26, 26, 26);
    font-size:12px;
    font-weight: 100;
    text-transform:capitalize;
    text-align: justify;
    /* font-style: italic; */
    /* line-height: 12px; */
    padding-left: 0px !important;

}

.drink-title-dnd-hidden {
        font-size:16px !important;
        font-weight:500 !important;
        color: rgb(158, 158, 158) !important;
        text-transform:uppercase !important;
        padding-top: 1px !important;
        padding-bottom: 0px !important;
        line-height: 1;
    }

.drink-subtitle-dnd-hidden {
        padding-top: 1px !important;
        padding-bottom: 0px !important;
        color: rgb(221, 221, 221) !important;
        font-size:14px !important;
		font-weight: 300 !important;
        line-height: 1;
        text-transform:capitalize !important;
        text-align: justify !important;
        /* line-height: 14px !important; */
        padding-left: 0px !important;

    }

.drink-strapline-dnd-hidden {
    padding-top: 1px;
    padding-bottom: 0px;
    color: rgb(221, 221, 221) !important;
    font-size:12px;
    font-weight: 200;
    text-transform:capitalize;
    text-align: justify;
    /* font-style: italic; */
    /* line-height: 12px; */
    padding-left: 0px !important;

}

.maxtall{
    max-height: 100px;
}

.price-row{
  padding-top: 0px;
  padding-bottom: 0px;
  padding-left: 40px;
  padding-right: 30px;


}

.toggle-r{
  padding-right: 50px;
}
.overflowcol{

    flex-shrink: 0;

}

.maxheightimg{
    max-height: 100px;
}
.aligncenter{
    justify-content:center
}
.aligntotheright{
  justify-content: flex-end;
}
.course_col {
    width: 360px;
    float: left;
    padding: 15px;
    margin-bottom: 25px;
    border-top-right-radius: 0px !important;
    border-bottom-left-radius: 0px !important;

}

.courseheading{
    font-size: 24px !important;
    font-weight: 600;
    text-align: center;
    border-radius: 0px !important;
    text-transform: uppercase;

}


.alignrigth{

    text-align: right;

}

.iconcolor{
    color: green !important;

}

.hiddenitem{
    columns: red;
}

.seperatordrinkdnd{
    background-color: rgb(125, 125, 125) !important;
    /* background-color: rgb(129, 129, 129) !important; */
    border-radius: 0px;


}

.inactive-separator{
    background-color: rgb(150, 150, 150) !important;
    /* background-color: rgb(129, 129, 129) !important; */
    border-radius: 2px;
    color:white !important;

}

.white-text-heading{
    color: white !important;
    font-weight: 600 !important;
    text-decoration: ;
}



.compact-form {
    transform: scale(1.5);
    transform-origin: right;
}


/* @-webkit-keyframes bounce {
        0% {
    transform: scale(1,1) translate(0px, 0px);
  }

  30%{
    transform: scale(1,0.8) translate(0px, 15px);
  }

  75%{
    transform: scale(1,1.1) translate(0px, 1px);
  }

 100% {
    transform: scale(1,1) translate(0px, 0px);
  }
} */


.wrap:hover .ball {
  -webkit-animation: bounce 1.75s infinite;
  animation-delay: 5000ms;
/* 	-webkit-animation: bounce 600ms linear; */
}

@-webkit-keyframes bounce {
  0% {
    -webkit-transform: translateY(0%);
  }
  18% {
    -webkit-transform: translateY(20%);
  }
  35% {
    -webkit-transform: translateY(-0%);
  }
  58% {
    -webkit-transform: translateY(10%);
  }
  77% {
    -webkit-transform: translateY(-0%);
  }
  90% {
    -webkit-transform: translateY(22%);
  }
  100% {
    -webkit-transform: translateY(-20%);
  }
}

.bounce {
      text-align:center;
      margin:0 auto;

     -webkit-animation: bounce 1.75s infinite;
}


.compact-toggle-dnd-1 {
    transform: scale(0.75);
    transform-origin: right;
}

.compact-toggle-dnd {
    transform: scale(0.5);
    transform-origin: right;
}


.inactivecogsimg{
    color: rgb(158, 158, 158) !important;
    /* opacity: .75; */
    /* color: rgb(176, 176, 176) !important; */
}

.dnd-card-height{
    max-height: 50px;
}

.dnd-drink-image-max{
    max-height: 100px;
    align-items: ;
    border-top-left-radius: 5px !important;
    border-bottom-left-radius: 5px !important;
    position: relative !important;
    top: 0%;
    left: 0%;
}
.section-spread{
    justify-content: space-between;
}

 .close-menu-right{
    position: fixed;
    right: 0px;
    top: 0px;
    }

    .close-menu-left{
    position: fixed;
    left: 0px;
    top: 0px;
    }

.inactiveimg{
    opacity: .25;
    border-bottom-left-radius: 3px;
    border-top-left-radius: 3px;
}

.inactivecogs{
    color: rgb(158, 158, 158) !important;
    /* opacity: .75; */
    /* color: rgb(176, 176, 176) !important; */
}

.hidden-text-heading{
    color: rgb(158, 158, 158) !important;
    font-weight: 600 !important;
}

.inactiveimg{
    opacity: .25;
}

.retailimg{
    border-bottom-left-radius: 3px;
    border-top-left-radius: 3px;
}
.struckout{
    text-decoration: line-through;
}
.compact-toggle-dnd-1 {
    transform: scale(0.75);
    transform-origin: right;
}

.compact-toggle-dnd {
    transform: scale(0.5);
    transform-origin: right;
}
.zzorganebg{
    background-color: #FE5800;
    color: white;
}
.title-icon{
    color: white !important;
    font-size: 50px;

}

</style>
